import { Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getVehicleOptionals } from "../../data/vehicle";
import CheckboxCustom from "../generic/CheckboxCustom";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";
import { BrandType, VehicleOptionType } from "@bus/models";

export const Equipment = () => {
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const { t } = useTranslation(["question3page"]);
    const { values, setFieldValue } = useFormikContext<IMatchMakerAnswers>();
    const handleOnChange = (e: string) => {
        let currentValues = [...(values["optionals"] || [])];
        if (currentValues.includes(e as VehicleOptionType)) {
            currentValues.splice(currentValues.indexOf(e as VehicleOptionType), 1);
        } else {
            currentValues.push(e as VehicleOptionType);
        }
        setFieldValue("optionals", currentValues);
    };

    const getTitle = () => {
        switch (brand) {
            case BrandType.VW:
            case BrandType.SKODA:
                return t("question3page:equipment.titleAlternative");
            case BrandType.VWN:
                return t("question3page:equipment.titleVWN");
            case BrandType.AUDI:
                return t("question3page:equipment.titleAudi")
            default:
                return t("question3page:equipment.title");
        }
    }
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{getTitle()}</Heading>
            <Layout>
                {getVehicleOptionals(t).map((optional, index) => (
                    <CheckboxCustom
                        handleOnChange={handleOnChange}
                        values={values}
                        defaultOption="1/2"
                        key={"optionals" + index}
                        item={optional}
                        fieldName="optionals"
                    />
                ))}
            </Layout>
        </>
    );
};
